import { LogOut, User } from "lucide-react";

export default function Topbar() {
    const logout = () => {
        localStorage.removeItem("token");
        window.location.href = "/login";
    };

    return (
        <div className="flex justify-between items-center px-6 py-4 border-b border-white/10 bg-white/5 backdrop-blur-xl">

            {/* Title */}
            <h1 className="text-lg font-semibold tracking-wide">
                Dashboard
            </h1>

            {/* Right */}
            <div className="flex items-center gap-4">
                <div className="flex items-center gap-2 bg-white/10 px-3 py-1 rounded-xl">
                    <User size={16} />
                    Admin
                </div>

                <button
                    onClick={logout}
                    className="bg-red-500 hover:bg-red-600 px-4 py-1 rounded-xl flex items-center gap-2"
                >
                    <LogOut size={16} />
                    Logout
                </button>
            </div>
        </div>
    );
}